const lockReleasers = new Map<string, () => void>();

const hasLocksApi = () => typeof navigator !== 'undefined' && 'locks' in navigator;

/**
 * Try to acquire a Web Lock shared across same-origin tabs, windows, and iframes.
 * Returns false when another context already holds the lock.
 */
export const acquireLock = async (lockId: string): Promise<boolean> => {
  if (!hasLocksApi()) {
    return true;
  }

  if (lockReleasers.has(lockId)) {
    return true;
  }

  return new Promise((resolve) => {
    navigator.locks.request(lockId, { ifAvailable: true }, async (lock) => {
      if (!lock) {
        resolve(false);
        return;
      }

      let release!: () => void;
      const held = new Promise<void>((heldResolve) => {
        release = heldResolve;
      });

      lockReleasers.set(lockId, () => {
        lockReleasers.delete(lockId);
        release();
      });

      resolve(true);
      await held;
    });
  });
};

export const releaseLock = (lockId: string) => {
  lockReleasers.get(lockId)?.();
};
